import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'

//React Router Dom used to create route paths for the web app
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
// Import Admin Authentication function
import requireAuth from './utils/requireAuth'
// Import Login Authenctication for Regular users
import loginPages from './utils/loginPages'
//Import Footer
import Footer from './components/Footer';
//Import main Views
import EventList from './views/EventList'
import EventManagement from './views/EventManagement'
import ProfilePage from './views/ProfilePage'
import AdminRegister from './views/AdminRegister'
import EventRegister from './views/EventRegister'
import ResetPasswordRequest from './views/ResetPasswordRequest'
import ResetPassword from './views/ResetPassword'
import CreateEmailTemplate from './views/EmailViews/CreateEmailTemplate';
import { emailCreateTemplateLink, emailEditTemplateLink, emailSendEmailLink, emailSentEmailsLink, emailTemplatesLink } from './routeLinks';
import PageNotFound from './views/PageNotFound';
import SentEmailList from './views/EmailViews/SentEmailList';
import EmailTemplateList from './views/EmailViews/EmailTemplateList';
import SendEmail from './views/EmailViews/sendEmail/SendEmailComponent';
import EditEmailTemplate from './views/EmailViews/EditEmailTemplate';
import AGM from './views/AGM/AGM'
import CreateEvent from './views/CreateEvent';
import DonationSuccess from './views/DonationSuccess';
import DonationError from './views/DonationError';
import DonationSection from './components/sharedComponents/DonationSection';

const ProfilePageRoute = loginPages(ProfilePage)
const ResetPasswordRequestRoute = loginPages(ResetPasswordRequest)
const ResetPasswordRoute = loginPages(ResetPassword)
const EventListRoute = requireAuth(EventList)
const EventManagementRoute = requireAuth(EventManagement)
const CreateEventRoute = requireAuth(CreateEvent)
const EventRegisterRoute = loginPages(EventRegister)
const AGMRoute = loginPages(AGM, false, true)
const CreateEmailTemplateRoute = loginPages(CreateEmailTemplate, true)
const EmailTemplateListRoute = loginPages(EmailTemplateList, true)
const SendEmailRoute = loginPages(SendEmail, true)
const SentEmailListRoute = loginPages(SentEmailList, true)
const EditEmailTemplateRoute = loginPages(EditEmailTemplate, true)

const App = () => {
    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path='/' element={<ProfilePageRoute />} />
                <Route path='/resetpassword' element={<ResetPasswordRequestRoute />} />
                <Route path='/changepassword/:token' element={<ResetPasswordRoute />} />
                <Route path='/eventlist' element={<EventListRoute />} />
                <Route path='/eventlist/new' element={<CreateEventRoute />} />
                <Route path='/eventmanagement' element={<EventManagementRoute />} />
                <Route path='/adminregister' element={<AdminRegister />} />
                <Route path='/eventregister' element={<EventRegisterRoute />} />
                <Route path='/agm' element={<AGMRoute />} />
                {/* EMAIL */}
                <Route path={emailCreateTemplateLink} element={<CreateEmailTemplateRoute />} />
                <Route path={emailTemplatesLink} element={<EmailTemplateListRoute />} />
                <Route path={emailSendEmailLink} element={<SendEmailRoute />} />
                <Route path={emailSentEmailsLink} element={<SentEmailListRoute />} />
                <Route path={emailEditTemplateLink} element={<EditEmailTemplateRoute />} />

                <Route path='/donation/success' element={<DonationSuccess />} />
                <Route path='/donation/error' element={<DonationError />} />

                <Route path='*' element={<PageNotFound />} />
            </Routes>
            <DonationSection />
            <Footer />
        </Router>
    );
}

export default App;
